import { FormGroup } from '@angular/forms';
import { STATES } from '@tangilla/tg-ng-models';
import { Injectable } from '@angular/core';
import { SurveyService } from '../../../../core/services/survey/survey.service';

@Injectable({
  providedIn: 'root'
})
export class M1SearchFormWidgetJson {
  constructor(private surveyService: SurveyService) {
  }

  getWidgetJson(form: FormGroup, model: any) {

    const findYourNrdsOptions = [
      ...(this.surveyService.surveyModel.getQuestionByName('LicenseHeld') && this.surveyService.surveyModel.getQuestionByName('LicenseHeld').value !== 'Yes' ? [] : [{
        'value': 'LIC',
        'text': this.getLicenseChoiceText()
      }]),
      {
        'value': 'NAME',
        'text': this.getNameChoiceText()
      },
      {
        'value': 'NAMESTATE',
        'text': this.getNameStateChoiceText()
      },
      {
        'value': 'NRDS',
        'text': 'Search by your NRDS number (If you know it you can enter it for us to validate)'
      },
    ];

    // if (this.surveyService.surveyModel.getVariable('office_class_transition_enabled') && !this.surveyService.surveyModel.getQuestionByName('CorporateAffiliate')) {
    findYourNrdsOptions.push({
      'value': 'NOTNAR',
      'text': 'I am not a member of the National Association of REALTORS® (NAR) currently'
    });
    // }

    return {
      valueChangesFunctions: {} as any,
      wrapperClass: 'row',
      questions: [
        {
          'type': 'radiogroup',
          'name': 'NRDSSearch',
          'isRequired': true,
          'title': '',
          'description': '',
          'choices': findYourNrdsOptions,
          formControl: form.get('nrds_search'),
          controlVisibleIf: () => !model?.jsonObj?.allowOnlyMemberNRDSID,
          controlName: 'nrds_search'
        }, {
          'type': 'text',
          'name': 'NRDSnum',
          'title': 'Enter your NRDS Number',
          'inputFormat': '99999999[9]',
          'mask': '099999999',
          'placeholder': '',
          'includeInOutput': false,
          'requiredErrorText': 'Please enter your NRDS Number',
          controlVisibleIf: () => model?.jsonObj?.allowOnlyMemberNRDSID || this.showFieldsForNrdsSearch(form, 'NRDS')(),
          'isRequired': true,
          formControl: form.get('member_nrds_id'),
          controlName: 'member_nrds_id'
        },
        {
          'type': 'dropdown',
          'name': 'NRDSstate',
          controlVisibleIf: this.showFieldsForNrdsSearch(form, 'NAMESTATE'),
          'title': 'State',
          'includeInOutput': false,
          'description': 'Select the state you last held a REALTOR® membership in',
          'isRequired': true,
          'requiredErrorText': 'Please select a State',
          'choices': STATES.map(state => {
            return {
              value: state,
              label: state
            };
          }),
          class: 'col-sm-12 col-md-5',
          formControl: form.get('state'),
          controlName: 'state'
        },
        {
          type: 'radiogroup',
          name: 'NRDS',
          titleLocation: 'hidden',
          title: 'Select your NRDS Record from the options below',
          requiredErrorText: 'You need to select your NRDS number to continue.',
          isRequired: true,
          visible: false,
          includeInProcessor: false,
          choices: [],
          validators: [
            {
              'type': 'expression',
              'text': 'If you have selected your NRDS, press next to continue.',
              'expression': '{nrds_validated}'
            }
          ],
          formControl: form.get('nrds_member'),
          controlName: 'nrds_member'
        },
        {
          'type': 'text',
          'name': 'NRDSMemberAssociationId',
          'includeInOutput': true,
          'visible': false
        },
        {
          'type': 'text',
          'name': 'NRDSMemberStateAssociationId',
          'includeInOutput': true,
          'visible': false
        }
      ],
    };
  }

  showFieldsForNrdsSearch(form: FormGroup, value: string) {
    const that = this;

    return () => {
      return form.get('nrds_search')?.value === value;
    };
  }

  getLicenseChoiceText() {
    const that = this;

    return () => {
      return `Search by your ${that.surveyState || ''} License Number (#${that.surveyLicenseNumber || ''})`;
    };
  }

  getNameChoiceText() {
    const that = this;

    return () => {
      return `Search by your Name (${that.surveyFirstName || ''} ${that.surveyLastName || ''}) and State (${that.surveyState})`;
    };
  }

  getNameStateChoiceText() {
    const that = this;

    return () => {
      return `Search by your Name (${that.surveyFirstName || ''} ${that.surveyLastName || ''}) and another State (where you were a member previously)`;
    };
  }

  get surveyState() {
    return this.surveyService.surveyModel.getVariable('v-state');
  }

  get surveyLicenseNumber() {
    return this.surveyService.surveyModel.getQuestionByName('LicNumber')?.value;
  }

  get surveyFirstName() {
    return this.surveyService.surveyModel.getQuestionByName('FirstName')?.value;
  }

  get surveyLastName() {
    return this.surveyService.surveyModel.getQuestionByName('LastName')?.value;
  }
}

/*'visibleIf': '{office_request_error}isempty',*/
